import * as AriaRoles from '../AriaRoles/AriaRoles.js'

export const renderTemplate = () => {
  const label = document.createElement('div')
  label.className = 'Label'
  const root = document.createElement('div')
  root.className = 'ListItem SearchResults'
  root.role = AriaRoles.Option
  root.append(label)
  return {
    root,
    label,
  }
}

export const renderElement = (template, data, index) => {
  template.label.textContent = data.text
  template.root.id = `item-${index}`
  template.root.dataset.index = index
}
